
import {clsx} from 'external/clsx'
import { FC, useMemo } from 'external/react'

type SubscriptionActionProps = {
    index: number
    status: string
    label?: string
    disabled?: boolean
    onClick: (index:number, status: string) => void
}
const btnClasses = {
  'active': 'btn-danger',
  'pending': 'btn-success',
  'canceled': 'btn-dark',
  'past_due': 'btn-warning'
}

const btnLabels = {
  'active': 'Cancelar',
  'pending': 'Reactivar',
  'canceled': 'Subscripción cancelada',
  'past_due': 'Ver detalles'
}

const SubscriptionAction:FC<SubscriptionActionProps> = props => {
  const {index, status, label, onClick} = props
  const btnClass = useMemo(() => btnClasses[status], [status])
  const btnLabel = useMemo(() => label || btnLabels[status], [status, label])
  const disabled = useMemo(() => props.disabled !== undefined ? props.disabled : status === 'canceled', [props.disabled, status])
  return (
    <div className='col-md-2 d-flex subscription-action' style={{cursor: 'pointer'}}>
      <button className={clsx('btn', btnClass, 'w-100', {disabled})} onClick={() => onClick(index, status)}>{btnLabel}</button>
    </div>
  )

}

export {SubscriptionAction as default}
